import React from 'react';
import styled, { css } from 'styled-components';

const BtnPrincipal = (props) => {
  return (
    <Btn
      className="btn btn-primary"
      {...props}
      primary
      style={{ borderRadius: '28px' }}
    >
      {props.label || 'BUTTON'}
    </Btn>
  );
};

export default BtnPrincipal;

const Btn = styled.button`
  ${(props) =>
    props.primary &&
    css`
      color: ${(props) => props.color};
      background-color: ${(props) => props['background-color']};
      margin-left: auto;
      margin-right: auto;
      :hover {
        background-color: ${(props) => props['background-color-hover']};
        color: ${(props) => props['color-hover']};
      },
    `}
`;
